<div class="box">
  <div class="content">
    <rt-icon name="lock" size="medium" colorToken="colorIconDisabled" />
    <div class="text-container">
      <span class="heading">
        {{
          'tlc.members.edit_member.permission_access_tab.invite_member_without_access_box.title'
            | translate
        }}
      </span>
      <span>
        {{
          'tlc.members.edit_member.permission_access_tab.invite_member_without_access_box.subtitle'
            | translate
        }}
      </span>
    </div>
  </div>
  <rt-button variant="primary" (click)="inviteClick.emit()">
    <rt-icon name="send" />
    <span>
      {{
        'tlc.members.edit_member.permission_access_tab.invite_member_without_access_box.invite'
          | translate
      }}</span
    >
  </rt-button>
</div>
